import * as React from "react";

// This is a drop in replacement for material ui TextField
export const NativeLinearProgress = (props: {
    style?: React.CSSProperties,
    value: number
}) => {
    return (
        <div
            style={{
                height: 4,
                display: "block",
                borderRadius: 2,
                overflow: "hidden",
                ...props.style
            }}
        >
            <div
                className="theme-progress-color"
                style={{
                    width: `${props.value}%`,
                    height: "100%",
                    transition: "width 0.3s"
                }}
            />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/NativeLinearProgress.tsx